import React from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { PageTypeTree } from "./PageTypeTree";

function PageTypesDashboard(props) {

    return (
        <div className="searchMain">
            <div style={{ "width": "80%", "margin": "auto" }}>
                <Tabs>
                    <TabList>
                        <Tab>Page Types</Tab>
                        <Tab>Page Groups</Tab>
                        <Tab>Mappings</Tab>
                        <Tab>Training Sets</Tab>
                        <Tab>ML Models</Tab>
                    </TabList>
                    <TabPanel>
                        Types
                    </TabPanel>
                    <TabPanel>
                        Groups
                    </TabPanel>
                    <TabPanel>
                        <PageTypeTree />
                    </TabPanel>
                    <TabPanel>
                        Training Sets
                    </TabPanel>
                    <TabPanel>
                        ML Models
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );


}



export { PageTypesDashboard }